// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chargingMainDiv_Bus .btn-primary{
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
}
.chargingMainDiv_Bus .btn-outline-primary{
  border-color: #83A4CF !important;
  color: #83A4CF !important;
}
.chargingMainDiv_Bus .ev_filter_icon {
  background: #fff !important;
  color: #83A4CF !important;
}

/* imp code commented */
/* .chargingMainDiv_Bus .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target{
  color: #fff !important;
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
} */
/* imp code commented */

/*********************** Slow Button *************************/
.kpiSlowBTN_Bus .btn-outline-primary{
  /* color:#83A4CF; */
  border-color:#83A4CF !important;
}
.kpiSlowBTN_Bus .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {
  box-shadow: none;
}
.kpiSlowBTN_Bus .btn-outline-primary {
  --bs-btn-color: #83A4CF !important;
  --bs-btn-border-color: #83A4CF !important;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #83A4CF !important;
  --bs-btn-hover-border-color: #83A4CF !important;
  --bs-btn-focus-shadow-rgb: 13,110,253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #83A4CF !important;
  --bs-btn-active-border-color: #83A4CF !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #83A4CF !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #83A4CF !important;
  --bs-gradient: none;
}

.kpiSlowBTN_Bus .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show>.btn-outline-primary.dropdown-toggle {
  /* color: #fff; */
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
  }
  .kpiSlowBTN_Bus .ev_SButton {
    background: none !important;
    color: #7b7878 !important;
    border-color: #7b7878 !important;
  }

/* imp code commented */
/* .kpiSlowBTN_Bus .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target{
  color: #fff !important;
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
} */
/* imp code commented */

.kpiSlowBTN_Bus .btn-outline-primary:hover{
  background-color: #83A4CF !important;
  border-color: #83A4CF !important;
}
/*********************** Slow Button Ends *************************/


/*********************** Fast Button *************************/
.kpiFastBTN_Bus .btn-outline-warning{
  /* color:#3578b0; */
  /* border-color:#3578b0 !important; */
}
.kpiFastBTN_Bus .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {
  box-shadow: none;
}
.kpiFastBTN_Bus .btn-outline-warning {
  --bs-btn-color: #3578b0 !important;
  --bs-btn-border-color: #3578b0 !important;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #3578b0 !important;
  --bs-btn-hover-border-color: #3578b0 !important;
  --bs-btn-focus-shadow-rgb: 255,193,7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #3578b0 !important;
  --bs-btn-active-border-color: #3578b0 !important;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #3578b0 !important;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #3578b0 !important;
  --bs-gradient: none;
}

.kpiFastBTN_Bus .ev_FButton {
  background: none !important;
  /* color: #3578b0 !important; */
  /* background: #7b7878 !important; */
  /* border: #7b7878; */
  border-color: #7b7878;
}

/* imp code commented */
/* .kpiFastBTN_Bus .btn:focus,
.btn:focus-visible,
.btn:focus-within,
.btn:hover,
.btn:visited,
.btn:active,
.btn:target{
  color: #fff !important;
  background-color: #3578b0;
  border-color: #3578b0;
} */
/* imp code commented */
/*********************** Fast Button Ends *************************/

.bg-white{
	background-color:#fff;
}

.chargingMainDiv_Bus{
	/* margin-top:80px; */
  margin-top: 15px;
}

.chargingWidget_Bus{
	/* background: #fff; */
	box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);
	border-radius: 5px;
  background: #CDDAEA;
}
.chargingWidgetIcon_Bus img{
	width:50px;
	height:50px;
}
.chargingWidgetIcon1_Bus img{
	width:35px;
	height:35px;
}
.chargingWidgetIcon_Bus-32_Bus img{
	width:32px;height:32px;
}
.chargingTitleBg_Bus {
  /* font-size: 1em;
  color: #0E3157;
  font-weight: 500;
  margin-bottom: 10px;
  text-align: left;
  background: #E0E0E0;
	border-radius: 5px 5px 0 0; */

  font-size: 1em;
  color: #0E3157;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  background: #E0E0E0;
  border-radius: 5px 5px 0 0;
  /* margin-top: -12px;
  margin-left: -10px;
  margin-right: -10px; */
}
/* .chargingTitleChart_Bus {
    font-size: 0.9em;
    color: #0E3157;
    font-weight: 600;
    margin-bottom: 5px;
    text-align: left;
    background: #E0E0E0;
	  border-radius: 5px 5px 0 0;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
} */

.chargingTitleChart_Bus_fleet {
    font-size: 0.9em;
    color: #0E3157;
    /* color: #353535; */
    font-weight: 600;
    margin-bottom: 5px;
    text-align: left;
    background: #E0E0E0;
	  border-radius: 5px 5px 0 0;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
}


/* .secondtable {
  border-collapse: collapse;
  width: 100%;
} */
.secondtable {
  border-collapse: separate; /* Change from collapse to separate */
  border-spacing: 0; /* Ensure no spacing between borders */
  width: 100%;
  border-radius: 5px; /* Add border radius to the table */
  overflow: hidden; /* Ensure the corners are rounded */
  border: 1px solid #46484b; /* Add a border to the table */
}

.secondtable th, .secondtable td {
  /* border: 1px solid #ddd; */
  border: 1px solid #46484b;
  /* border-radius: 3px solid #46484b; */
  padding: 8px;
  text-align: center;
}

.secondtable th {
  background-color: #83A4CF;
  color: #fff;
  font-size: 13px;
}

/* .secondtable tbody tr:nth-child(even) {
  background-color: #f2f2f2;
} */

/* Add lines after each column */
.secondtable th:not(:last-child), .secondtable td:not(:last-child) {
  /* border-right: 1px solid #ddd; */
  border-right: 1px solid #46484b;
}


.chargingChartbox_Bus{
	/* background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    color: #353535;
	min-height: 280px;
	border-radius: 5px; */
  background: #FFFFFF;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
}

.wd_Bus{
	min-height: 330px !important;
}
.wd_4_charts_Bus{
    min-height: 307px !important;
  }
.highlightBoxKpi_Bus{
	/* min-height: 310px !important; */
}
.highlightTableSec_Bus{
	min-height: 310px !important;
}
.chargingChartHGT_Bus{
    padding: 10px;
}

.chargingH5_Bus .h5 {
    font-size: 1rem !important;
    /* font-size: 1.1rem !important; */
}
.chargingKpiSmallTxt_Bus{
	font-size: 77% !important;
    line-height: 1em !important;
}

.tableContent_Bus table tr td {
	font-size:0.8em;
}

.chargingFilterForm_Bus > .form-label{
	font-size:0.825em;
}

.chargingHeadfont_Bus{
	font-size:1.8rem;
}
.topRightDropMenu_Bus .dropdown-menu[data-bs-popper] {
    right:0 !important;
	left: auto;
}

/********************  *********************/

.contentScroll_Bus{
	/* overflow-y: scroll; */
	/* height:150px; */
}

.chargingWidget_Bus p {
    line-height: 1rem !important;
}
.chargingWidget_Bus p small{
	font-size:80% !important;
}

/***************************** Toggle Switch ***************************/
.toggleBtn_Bus .form-switch .form-check-input:checked:before {
    content: "C";
    position: absolute;
    width: 20px;
    height: 10px;
    padding-left: 20px;
    margin-top: -1px;
    font-size: 0.7em;
}
.toggleBtn_Bus .form-switch .form-check-input:before{
	content: "V";
    position: absolute;
    width: 20px;
    height: 10px;
    padding-left: 5px;
    margin-top: -1px;
    font-size: 0.7em;
}
.toggleBtn_Bus .form-switch .form-check-input{
	color:#83A4CF !important;
}

/* k */
.toggleBtn_Bus .toggle-button-cover {
  position: relative;
  top: 8px;
}
.dropdownSelectBtnCharging_Bus{
	width: fit-content;
}
.toggleBtn_Bus .button-cover {
  background-color: #fff;
  box-shadow: 0 10px 20px -8px #c5d6d6;
  border-radius: 4px;
}

.toggleBtn_Bus .button-cover:before {
  color: #d7e3e3;
  font-size: 12px;
  line-height: 1;
  padding: 5px;
}

.toggleBtn_Bus .button-cover,
.knobs,
.layer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.toggleBtn_Bus .buttonbtn {
  position: relative;
  top: 50%;
  width: 50px;
}

.toggleBtn_Bus .buttonbtn.r,
.buttonbtn.r .layer {
  border-radius: 100px;
}

.toggleBtn_Bus .button.b2 {
  border-radius: 2px;
}

.toggleBtn_Bus .checkbox {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}

.toggleBtn_Bus .knobs {
  z-index: 2;
}

.toggleBtn_Bus .layer {
  width: 100%;
  background-color: #ebf7fc;
  transition: 0.3s ease all;
  z-index: 1;
}
/* Button 1 */
#button-1_Bus .knobs:before {
  content: "V";
  position: absolute;
  top: 0px;
  left: 0px;
  width: 20px;
  height: 20px;
  color: #fff;
  font-size: 10px;
  font-weight: bold;
  text-align: center;
  line-height: 1;
  padding: 6px 4px;
  background-color: #83A4CF;
  border-radius: 50%;
  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;
}

#button-1_Bus .checkbox:checked + .knobs:before {
  content: "C";
  left: 30px;
  background-color: #3578b0;
}

#button-1_Bus .checkbox:checked ~ .layer {
  /* fent orange change */
  /* background-color: #fcebeb; */
  background-color: #94c1e6;
}

#button-1_Bus .knobs,
#button-1_Bus .knobs:before,
#button-1_Bus .layer {
  transition: 0.3s ease all;
}

/***************************** PageTwo *******************************/

/*************************  *****************************/
.kpiNotificationSlow_Bus{
	color: #83A4CF;
    font-size: 0.7em;
    font-weight: 500;
}
.kpiNotificationFast_Bus{
	color:#3578b0;
	font-size:0.7em;
	font-weight:500;
}

.kpiNotificationBoth_Bus{
	color:#72D817;
	font-size:0.7em;
	font-weight:500;
}
/* media queries start here */

@media (min-width: 1440px) {
.col205{
	flex: 0 0 auto;
    width: 20% !important;
}
}

@media (max-width: 1440px) {
.highlightTableSec_Bus{
	min-height: 310px !important;
}
}

@media (min-width: 1336px) {
.col205{
	flex: 0 0 auto;
    width: 20% !important;
}
}


@media (max-width: 1024px) {
.highlightTableSec_Bus{
	min-height: 330px !important;
}
}


@media (min-width: 992px) {
.col205{
	flex: 0 0 auto;
    width: 20% !important;
}
}


@media (min-width: 836px) {
/* .navbar-expand-sm { */
    /* flex-wrap: nowrap !important; */
    /* justify-content: flex-start !important; */
/* } */
}

@media screen and (max-width: 740px) {
.chargingTitleBg_Bus {
	font-size: 0.9em;
}
}


@media screen and (max-width: 720px) {
/* .chargingMainDiv_Bus{ */
	/* margin-top:124px; */
/* } */
}

@media screen and (max-width: 480px) {
/* .chargingMainDiv_Bus{ */
	/* margin-top:155px; */
/* } */
}
	
@media screen and (max-width: 480px) {

.chargingHeadfont_Bus {
    font-size: 1rem;
}
.chargingTitleBg_Bus {
	font-size: 0.9em;
}
}

@media screen and (max-width: 320px) {

}

.highlight_five_Bus{
  margin: auto;
}

.text_bottom_Bus{
  margin-bottom: '-16px !important';
  display: none;
  z-index: 1;
}
.btn-infotable_Bus:active {
  color: black;
  background-color: #fff;
  border-color: #32879c; 
}

/* .col-19 {
  flex: 0 0 calc(100% / 19);
  max-width: calc(100% / 19);
} */

@media (min-width: 1440px) {
  .col-19 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 19);
  max-width: calc(100% / 19);
  }
}

@media (min-width: 1336px) {
  .col-19 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 19);
  max-width: calc(100% / 19);
  }
}

@media (min-width: 992px) {
  .col-19 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(100% / 19);
  max-width: calc(100% / 19);
  }
}


/* @media (max-width: 576px) {
  .col-19 {
      flex: 0 0 calc(100% / 19);
      max-width: calc(100% / 19);
    }
}

@media (min-width: 576px) and (max-width: 768px) {
  .col-19 {
      flex: 0 0 calc(100% / 19);
      max-width: calc(100% / 19);
    }
}

@media (min-width: 768px) and (max-width: 992px) {
  .col-19 {
      flex: 0 0 calc(100% / 19);
      max-width: calc(100% / 19);
    }
}

@media (min-width: 992px) {
  .col-19 {
      flex: 0 0 calc(100% / 19);
      max-width: calc(100% / 19);
    }
} */

.main_hole_background{
  background-color: #F2F3FC;
  /* height: 530px; */
  /* min-height: 90vh; 
  display: flex;
  flex-direction: column; */
}

.chargingChartboxNew_Bus {
  background: #FFFFFF;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  height: 293px;
  /* height: 333px; */
  border-radius: 5px 5px 0 0;
}
.chargingChartboxNew2_Bus {
  background: #FFFFFF;
  padding: 0px;
  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
  /* height: 293px; */
  height: 313px;
  border-radius: 5px 5px 0 0;
}

.highBold {
  font-weight: bold;
  color: black;
  font-size:16px !important
}

.filter_bus_icon_f .rca_btn .rca_btn_bus  {
  background-color: #ffa650;
}
.filter_bus_icon_f .rca_btn .rca_btn_bus:hover{
  background-color: #fcb877 !important; 
  border-color: #fcb877 !important;
}

.popUpTable{
  background-color: rgb(131, 164, 207);
  color: rgb(255, 255, 255);
  position: sticky;
  top: 0;
  z-index: 0;
}

.custom-table .p-datatable-thead th {
  background-color: #83A4CF;
  /* Set your desired background color */
  color: white;
  /* Set your desired text color */
}

/* .custom-table .p-sortable-column .p-column-title .p-sortable-column-icon.pi-sort { */
.custom-table .p-sortable-column .p-column-header-content .p-sortable-column-icon {
  color: white;
  height: 20px!important;
  width: 12px!important;
  /* Set your desired arrow color */
}

.even-row {
  background-color: pink;
}

.odd-row {
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Bus/CriticalVehicle_Bus_Fleet/CriticalCustom_Bus_fleet.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;;;;;;;;;;GAUG;AACH,uBAAuB;;AAEvB,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,qCAAqC;EACrC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,gCAAgC;EAChC;EACA;IACE,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;EAClC;;AAEF,uBAAuB;AACvB;;;;;;;;;;GAUG;AACH,uBAAuB;;AAEvB;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA,mEAAmE;;;AAGnE,8DAA8D;AAC9D;EACE,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,0BAA0B;EAC1B,qCAAqC;EACrC,+CAA+C;EAC/C,oCAAoC;EACpC,2BAA2B;EAC3B,sCAAsC;EACtC,gDAAgD;EAChD,4DAA4D;EAC5D,2CAA2C;EAC3C,iCAAiC;EACjC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;;;;;;;;;;GAUG;AACH,uBAAuB;AACvB,mEAAmE;;AAEnE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;EACpB,gBAAgB;AAClB;;AAEA;CACC,sBAAsB;CACtB,4CAA4C;CAC5C,kBAAkB;EACjB,mBAAmB;AACrB;AACA;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,UAAU;CACV,WAAW;AACZ;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;EACE;;;;;;8BAM4B;;EAE5B,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B;;wBAEsB;AACxB;AACA;;;;;;;;;GASG;;AAEH;IACI,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;GACpB,0BAA0B;IACzB,wCAAwC;AAC5C;;;AAGA;;;GAGG;AACH;EACE,yBAAyB,EAAE,qCAAqC;EAChE,iBAAiB,EAAE,sCAAsC;EACzD,WAAW;EACX,kBAAkB,EAAE,mCAAmC;EACvD,gBAAgB,EAAE,mCAAmC;EACrD,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;;AAEA;;GAEG;;AAEH,gCAAgC;AAChC;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;;AAGA;CACC;;;;sBAIqB;EACpB,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;CACC,4BAA4B;AAC7B;AACA;IACI,4BAA4B;EAC9B;AACF;CACC,kCAAkC;AACnC;AACA;CACC,4BAA4B;AAC7B;AACA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;AACA;CACC,yBAAyB;IACtB,2BAA2B;AAC/B;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;AACA;IACI,kBAAkB;CACrB,UAAU;AACX;;AAEA,4CAA4C;;AAE5C;CACC,wBAAwB;CACxB,kBAAkB;AACnB;;AAEA;IACI,4BAA4B;AAChC;AACA;CACC,wBAAwB;AACzB;;AAEA,wEAAwE;AACxE;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,YAAY;IACT,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,wBAAwB;AACzB;;AAEA,MAAM;AACN;EACE,kBAAkB;EAClB,QAAQ;AACV;AACA;CACC,kBAAkB;AACnB;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,yBAAyB;EACzB,UAAU;AACZ;AACA,aAAa;AACb;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA,sEAAsE;;AAEtE,yDAAyD;AACzD;CACC,cAAc;IACX,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,eAAe;CACf,eAAe;AAChB;AACA,6BAA6B;;AAE7B;AACA;CACC,cAAc;IACX,qBAAqB;AACzB;AACA;;AAEA;AACA;CACC,4BAA4B;AAC7B;AACA;;AAEA;AACA;CACC,cAAc;IACX,qBAAqB;AACzB;AACA;;;AAGA;AACA;CACC,4BAA4B;AAC7B;AACA;;;AAGA;AACA;CACC,cAAc;IACX,qBAAqB;AACzB;AACA;;;AAGA;AACA,wBAAwB;IACpB,kCAAkC;IAClC,4CAA4C;AAChD,MAAM;AACN;;AAEA;AACA;CACC,gBAAgB;AACjB;AACA;;;AAGA;AACA,0BAA0B;CACzB,sBAAsB;AACvB,MAAM;AACN;;AAEA;AACA,0BAA0B;CACzB,sBAAsB;AACvB,MAAM;AACN;;AAEA;;AAEA;IACI,eAAe;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;;AAEA;;AAEA;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,UAAU;AACZ;AACA;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;GAGG;;AAEH;EACE;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B,0BAA0B;EAC1B;AACF;;AAEA;EACE;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B,0BAA0B;EAC1B;AACF;;AAEA;EACE;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;EAC3B,0BAA0B;EAC1B;AACF;;;AAGA;;;;;;;;;;;;;;;;;;;;;;;;;;GA0BG;;AAEH;EACE,yBAAyB;EACzB,mBAAmB;EACnB;;2BAEyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ;AACF;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,YAAY;EACZ,gCAAgC;AAClC;;AAEA,uFAAuF;AACvF;EACE,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".chargingMainDiv_Bus .btn-primary{\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n}\n.chargingMainDiv_Bus .btn-outline-primary{\n  border-color: #83A4CF !important;\n  color: #83A4CF !important;\n}\n.chargingMainDiv_Bus .ev_filter_icon {\n  background: #fff !important;\n  color: #83A4CF !important;\n}\n\n/* imp code commented */\n/* .chargingMainDiv_Bus .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target{\n  color: #fff !important;\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n} */\n/* imp code commented */\n\n/*********************** Slow Button *************************/\n.kpiSlowBTN_Bus .btn-outline-primary{\n  /* color:#83A4CF; */\n  border-color:#83A4CF !important;\n}\n.kpiSlowBTN_Bus .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n  box-shadow: none;\n}\n.kpiSlowBTN_Bus .btn-outline-primary {\n  --bs-btn-color: #83A4CF !important;\n  --bs-btn-border-color: #83A4CF !important;\n  --bs-btn-hover-color: #fff;\n  --bs-btn-hover-bg: #83A4CF !important;\n  --bs-btn-hover-border-color: #83A4CF !important;\n  --bs-btn-focus-shadow-rgb: 13,110,253;\n  --bs-btn-active-color: #fff;\n  --bs-btn-active-bg: #83A4CF !important;\n  --bs-btn-active-border-color: #83A4CF !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #83A4CF !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #83A4CF !important;\n  --bs-gradient: none;\n}\n\n.kpiSlowBTN_Bus .btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show>.btn-outline-primary.dropdown-toggle {\n  /* color: #fff; */\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n  }\n  .kpiSlowBTN_Bus .ev_SButton {\n    background: none !important;\n    color: #7b7878 !important;\n    border-color: #7b7878 !important;\n  }\n\n/* imp code commented */\n/* .kpiSlowBTN_Bus .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target{\n  color: #fff !important;\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n} */\n/* imp code commented */\n\n.kpiSlowBTN_Bus .btn-outline-primary:hover{\n  background-color: #83A4CF !important;\n  border-color: #83A4CF !important;\n}\n/*********************** Slow Button Ends *************************/\n\n\n/*********************** Fast Button *************************/\n.kpiFastBTN_Bus .btn-outline-warning{\n  /* color:#3578b0; */\n  /* border-color:#3578b0 !important; */\n}\n.kpiFastBTN_Bus .btn-check:checked+.btn:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible, .btn:first-child:active:focus-visible, :not(.btn-check)+.btn:active:focus-visible {\n  box-shadow: none;\n}\n.kpiFastBTN_Bus .btn-outline-warning {\n  --bs-btn-color: #3578b0 !important;\n  --bs-btn-border-color: #3578b0 !important;\n  --bs-btn-hover-color: #000;\n  --bs-btn-hover-bg: #3578b0 !important;\n  --bs-btn-hover-border-color: #3578b0 !important;\n  --bs-btn-focus-shadow-rgb: 255,193,7;\n  --bs-btn-active-color: #000;\n  --bs-btn-active-bg: #3578b0 !important;\n  --bs-btn-active-border-color: #3578b0 !important;\n  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n  --bs-btn-disabled-color: #3578b0 !important;\n  --bs-btn-disabled-bg: transparent;\n  --bs-btn-disabled-border-color: #3578b0 !important;\n  --bs-gradient: none;\n}\n\n.kpiFastBTN_Bus .ev_FButton {\n  background: none !important;\n  /* color: #3578b0 !important; */\n  /* background: #7b7878 !important; */\n  /* border: #7b7878; */\n  border-color: #7b7878;\n}\n\n/* imp code commented */\n/* .kpiFastBTN_Bus .btn:focus,\n.btn:focus-visible,\n.btn:focus-within,\n.btn:hover,\n.btn:visited,\n.btn:active,\n.btn:target{\n  color: #fff !important;\n  background-color: #3578b0;\n  border-color: #3578b0;\n} */\n/* imp code commented */\n/*********************** Fast Button Ends *************************/\n\n.bg-white{\n\tbackground-color:#fff;\n}\n\n.chargingMainDiv_Bus{\n\t/* margin-top:80px; */\n  margin-top: 15px;\n}\n\n.chargingWidget_Bus{\n\t/* background: #fff; */\n\tbox-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11);\n\tborder-radius: 5px;\n  background: #CDDAEA;\n}\n.chargingWidgetIcon_Bus img{\n\twidth:50px;\n\theight:50px;\n}\n.chargingWidgetIcon1_Bus img{\n\twidth:35px;\n\theight:35px;\n}\n.chargingWidgetIcon_Bus-32_Bus img{\n\twidth:32px;height:32px;\n}\n.chargingTitleBg_Bus {\n  /* font-size: 1em;\n  color: #0E3157;\n  font-weight: 500;\n  margin-bottom: 10px;\n  text-align: left;\n  background: #E0E0E0;\n\tborder-radius: 5px 5px 0 0; */\n\n  font-size: 1em;\n  color: #0E3157;\n  font-weight: 600;\n  margin-bottom: 10px;\n  text-align: center;\n  background: #E0E0E0;\n  border-radius: 5px 5px 0 0;\n  /* margin-top: -12px;\n  margin-left: -10px;\n  margin-right: -10px; */\n}\n/* .chargingTitleChart_Bus {\n    font-size: 0.9em;\n    color: #0E3157;\n    font-weight: 600;\n    margin-bottom: 5px;\n    text-align: left;\n    background: #E0E0E0;\n\t  border-radius: 5px 5px 0 0;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n} */\n\n.chargingTitleChart_Bus_fleet {\n    font-size: 0.9em;\n    color: #0E3157;\n    /* color: #353535; */\n    font-weight: 600;\n    margin-bottom: 5px;\n    text-align: left;\n    background: #E0E0E0;\n\t  border-radius: 5px 5px 0 0;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n}\n\n\n/* .secondtable {\n  border-collapse: collapse;\n  width: 100%;\n} */\n.secondtable {\n  border-collapse: separate; /* Change from collapse to separate */\n  border-spacing: 0; /* Ensure no spacing between borders */\n  width: 100%;\n  border-radius: 5px; /* Add border radius to the table */\n  overflow: hidden; /* Ensure the corners are rounded */\n  border: 1px solid #46484b; /* Add a border to the table */\n}\n\n.secondtable th, .secondtable td {\n  /* border: 1px solid #ddd; */\n  border: 1px solid #46484b;\n  /* border-radius: 3px solid #46484b; */\n  padding: 8px;\n  text-align: center;\n}\n\n.secondtable th {\n  background-color: #83A4CF;\n  color: #fff;\n  font-size: 13px;\n}\n\n/* .secondtable tbody tr:nth-child(even) {\n  background-color: #f2f2f2;\n} */\n\n/* Add lines after each column */\n.secondtable th:not(:last-child), .secondtable td:not(:last-child) {\n  /* border-right: 1px solid #ddd; */\n  border-right: 1px solid #46484b;\n}\n\n\n.chargingChartbox_Bus{\n\t/* background: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    color: #353535;\n\tmin-height: 280px;\n\tborder-radius: 5px; */\n  background: #FFFFFF;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n}\n\n.wd_Bus{\n\tmin-height: 330px !important;\n}\n.wd_4_charts_Bus{\n    min-height: 307px !important;\n  }\n.highlightBoxKpi_Bus{\n\t/* min-height: 310px !important; */\n}\n.highlightTableSec_Bus{\n\tmin-height: 310px !important;\n}\n.chargingChartHGT_Bus{\n    padding: 10px;\n}\n\n.chargingH5_Bus .h5 {\n    font-size: 1rem !important;\n    /* font-size: 1.1rem !important; */\n}\n.chargingKpiSmallTxt_Bus{\n\tfont-size: 77% !important;\n    line-height: 1em !important;\n}\n\n.tableContent_Bus table tr td {\n\tfont-size:0.8em;\n}\n\n.chargingFilterForm_Bus > .form-label{\n\tfont-size:0.825em;\n}\n\n.chargingHeadfont_Bus{\n\tfont-size:1.8rem;\n}\n.topRightDropMenu_Bus .dropdown-menu[data-bs-popper] {\n    right:0 !important;\n\tleft: auto;\n}\n\n/********************  *********************/\n\n.contentScroll_Bus{\n\t/* overflow-y: scroll; */\n\t/* height:150px; */\n}\n\n.chargingWidget_Bus p {\n    line-height: 1rem !important;\n}\n.chargingWidget_Bus p small{\n\tfont-size:80% !important;\n}\n\n/***************************** Toggle Switch ***************************/\n.toggleBtn_Bus .form-switch .form-check-input:checked:before {\n    content: \"C\";\n    position: absolute;\n    width: 20px;\n    height: 10px;\n    padding-left: 20px;\n    margin-top: -1px;\n    font-size: 0.7em;\n}\n.toggleBtn_Bus .form-switch .form-check-input:before{\n\tcontent: \"V\";\n    position: absolute;\n    width: 20px;\n    height: 10px;\n    padding-left: 5px;\n    margin-top: -1px;\n    font-size: 0.7em;\n}\n.toggleBtn_Bus .form-switch .form-check-input{\n\tcolor:#83A4CF !important;\n}\n\n/* k */\n.toggleBtn_Bus .toggle-button-cover {\n  position: relative;\n  top: 8px;\n}\n.dropdownSelectBtnCharging_Bus{\n\twidth: fit-content;\n}\n.toggleBtn_Bus .button-cover {\n  background-color: #fff;\n  box-shadow: 0 10px 20px -8px #c5d6d6;\n  border-radius: 4px;\n}\n\n.toggleBtn_Bus .button-cover:before {\n  color: #d7e3e3;\n  font-size: 12px;\n  line-height: 1;\n  padding: 5px;\n}\n\n.toggleBtn_Bus .button-cover,\n.knobs,\n.layer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.toggleBtn_Bus .buttonbtn {\n  position: relative;\n  top: 50%;\n  width: 50px;\n}\n\n.toggleBtn_Bus .buttonbtn.r,\n.buttonbtn.r .layer {\n  border-radius: 100px;\n}\n\n.toggleBtn_Bus .button.b2 {\n  border-radius: 2px;\n}\n\n.toggleBtn_Bus .checkbox {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  margin: 0;\n  opacity: 0;\n  cursor: pointer;\n  z-index: 3;\n}\n\n.toggleBtn_Bus .knobs {\n  z-index: 2;\n}\n\n.toggleBtn_Bus .layer {\n  width: 100%;\n  background-color: #ebf7fc;\n  transition: 0.3s ease all;\n  z-index: 1;\n}\n/* Button 1 */\n#button-1_Bus .knobs:before {\n  content: \"V\";\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 20px;\n  height: 20px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: bold;\n  text-align: center;\n  line-height: 1;\n  padding: 6px 4px;\n  background-color: #83A4CF;\n  border-radius: 50%;\n  transition: 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15) all;\n}\n\n#button-1_Bus .checkbox:checked + .knobs:before {\n  content: \"C\";\n  left: 30px;\n  background-color: #3578b0;\n}\n\n#button-1_Bus .checkbox:checked ~ .layer {\n  /* fent orange change */\n  /* background-color: #fcebeb; */\n  background-color: #94c1e6;\n}\n\n#button-1_Bus .knobs,\n#button-1_Bus .knobs:before,\n#button-1_Bus .layer {\n  transition: 0.3s ease all;\n}\n\n/***************************** PageTwo *******************************/\n\n/*************************  *****************************/\n.kpiNotificationSlow_Bus{\n\tcolor: #83A4CF;\n    font-size: 0.7em;\n    font-weight: 500;\n}\n.kpiNotificationFast_Bus{\n\tcolor:#3578b0;\n\tfont-size:0.7em;\n\tfont-weight:500;\n}\n\n.kpiNotificationBoth_Bus{\n\tcolor:#72D817;\n\tfont-size:0.7em;\n\tfont-weight:500;\n}\n/* media queries start here */\n\n@media (min-width: 1440px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n}\n\n@media (max-width: 1440px) {\n.highlightTableSec_Bus{\n\tmin-height: 310px !important;\n}\n}\n\n@media (min-width: 1336px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n}\n\n\n@media (max-width: 1024px) {\n.highlightTableSec_Bus{\n\tmin-height: 330px !important;\n}\n}\n\n\n@media (min-width: 992px) {\n.col205{\n\tflex: 0 0 auto;\n    width: 20% !important;\n}\n}\n\n\n@media (min-width: 836px) {\n/* .navbar-expand-sm { */\n    /* flex-wrap: nowrap !important; */\n    /* justify-content: flex-start !important; */\n/* } */\n}\n\n@media screen and (max-width: 740px) {\n.chargingTitleBg_Bus {\n\tfont-size: 0.9em;\n}\n}\n\n\n@media screen and (max-width: 720px) {\n/* .chargingMainDiv_Bus{ */\n\t/* margin-top:124px; */\n/* } */\n}\n\n@media screen and (max-width: 480px) {\n/* .chargingMainDiv_Bus{ */\n\t/* margin-top:155px; */\n/* } */\n}\n\t\n@media screen and (max-width: 480px) {\n\n.chargingHeadfont_Bus {\n    font-size: 1rem;\n}\n.chargingTitleBg_Bus {\n\tfont-size: 0.9em;\n}\n}\n\n@media screen and (max-width: 320px) {\n\n}\n\n.highlight_five_Bus{\n  margin: auto;\n}\n\n.text_bottom_Bus{\n  margin-bottom: '-16px !important';\n  display: none;\n  z-index: 1;\n}\n.btn-infotable_Bus:active {\n  color: black;\n  background-color: #fff;\n  border-color: #32879c; \n}\n\n/* .col-19 {\n  flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n} */\n\n@media (min-width: 1440px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n}\n\n@media (min-width: 1336px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n}\n\n@media (min-width: 992px) {\n  .col-19 {\n    flex: 0 0 calc(100% / 19);\n  max-width: calc(100% / 19);\n  }\n}\n\n\n/* @media (max-width: 576px) {\n  .col-19 {\n      flex: 0 0 calc(100% / 19);\n      max-width: calc(100% / 19);\n    }\n}\n\n@media (min-width: 576px) and (max-width: 768px) {\n  .col-19 {\n      flex: 0 0 calc(100% / 19);\n      max-width: calc(100% / 19);\n    }\n}\n\n@media (min-width: 768px) and (max-width: 992px) {\n  .col-19 {\n      flex: 0 0 calc(100% / 19);\n      max-width: calc(100% / 19);\n    }\n}\n\n@media (min-width: 992px) {\n  .col-19 {\n      flex: 0 0 calc(100% / 19);\n      max-width: calc(100% / 19);\n    }\n} */\n\n.main_hole_background{\n  background-color: #F2F3FC;\n  /* height: 530px; */\n  /* min-height: 90vh; \n  display: flex;\n  flex-direction: column; */\n}\n\n.chargingChartboxNew_Bus {\n  background: #FFFFFF;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  height: 293px;\n  /* height: 333px; */\n  border-radius: 5px 5px 0 0;\n}\n.chargingChartboxNew2_Bus {\n  background: #FFFFFF;\n  padding: 0px;\n  box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n  /* height: 293px; */\n  height: 313px;\n  border-radius: 5px 5px 0 0;\n}\n\n.highBold {\n  font-weight: bold;\n  color: black;\n  font-size:16px !important\n}\n\n.filter_bus_icon_f .rca_btn .rca_btn_bus  {\n  background-color: #ffa650;\n}\n.filter_bus_icon_f .rca_btn .rca_btn_bus:hover{\n  background-color: #fcb877 !important; \n  border-color: #fcb877 !important;\n}\n\n.popUpTable{\n  background-color: rgb(131, 164, 207);\n  color: rgb(255, 255, 255);\n  position: sticky;\n  top: 0;\n  z-index: 0;\n}\n\n.custom-table .p-datatable-thead th {\n  background-color: #83A4CF;\n  /* Set your desired background color */\n  color: white;\n  /* Set your desired text color */\n}\n\n/* .custom-table .p-sortable-column .p-column-title .p-sortable-column-icon.pi-sort { */\n.custom-table .p-sortable-column .p-column-header-content .p-sortable-column-icon {\n  color: white;\n  height: 20px!important;\n  width: 12px!important;\n  /* Set your desired arrow color */\n}\n\n.even-row {\n  background-color: pink;\n}\n\n.odd-row {\n  background-color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
